<section class="location-section py-5" id="location">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="location-content">
          <h2 class="section-title">{{ i18n.getTranslation('location.title') }}</h2>
          <p class="section-subtitle">{{ i18n.getTranslation('location.subtitle') }}</p>

          <div class="location-info mb-4">
            <div class="info-item">
              <i class="fas fa-clock text-primary me-2"></i>
              <span>{{ i18n.getTranslation('location.timezone') }}</span>
            </div>
            <div class="info-item">
              <i class="fas fa-check-circle text-success me-2"></i>
              <span>{{ i18n.getTranslation('location.availability') }}</span>
            </div>
            <div class="info-item">
              <i class="fas fa-laptop text-info me-2"></i>
              <span>{{ i18n.getTranslation('location.remote') }}</span>
            </div>
            <div class="info-item">
              <i class="fas fa-handshake text-warning me-2"></i>
              <span>{{ i18n.getTranslation('location.onsite') }}</span>
            </div>
          </div>

          <h3 class="advantages-title">{{ i18n.getTranslation('location.advantages_title') }}</h3>

          <div class="advantages-grid">
            <div class="advantage-card" *ngFor="let advantage of locationAdvantages">
              <div class="advantage-icon">
                <i [class]="advantage.icon"></i>
              </div>
              <div class="advantage-content">
                <h5 class="advantage-title">{{ advantage.title }}</h5>
                <p class="advantage-description">{{ advantage.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="location-image">
          <img src="assets/images/lviv_silhouette.png" alt="Lviv City" class="img-fluid rounded">
          <div class="location-overlay">
            <div class="location-badge">
              <i class="fas fa-map-marker-alt"></i>
              <span>Lviv, Ukraine</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
